<div class="row text-center">
  <div class="col-md-4">
    <div
      class="btn"
      mwlCalendarPreviousView
      [view]="view"
      [(viewDate)]="viewDate"
      (viewDateChange)="closeOpenMonthViewDay()"
    >
      <button
        style="
          background-color: #343a40;
          color: white;
          width: 50px;
          height: 40px;
          border-radius: 10px;
        "
        class="mat-elevation-z2"
        mat-button
      >
        <i class="fa fa-arrow-left"></i>
      </button>
    </div>

    <div
      class="btn btn-outline-secondary mat-elevation-z2"
      mwlCalendarToday
      [(viewDate)]="viewDate"
    >
      HOY
    </div>

    <div
      class="btn"
      mwlCalendarNextView
      [view]="view"
      [(viewDate)]="viewDate"
      (viewDateChange)="closeOpenMonthViewDay()"
    >
      <button
        style="
          background-color: #343a40;
          color: white;
          width: 50px;
          height: 40px;
          border-radius: 10px;
        "
        class="mat-elevation-z2"
        mat-button
      >
        <i class="fa fa-arrow-right"></i>
      </button>
    </div>
  </div>

  <div class="col-md-4" style="display: flex; justify-content: center; align-items: center;">
    <h2>{{ viewDate | calendarDate: view + "ViewTitle":locale }}</h2>
  </div>

  <div class="col-md-4">
    <div
      class="btn"
      (click)="setView(CalendarView.Month)"
      [class.active]="view === CalendarView.Month"
    >
      <button
        class="mat-elevation-z2 p-0"
        mat-raised-button
        style="
          background-color: #343a40;
          color: white;
          width: 50px;
          height: 40px;
          border-radius: 10px;
        "
      >
        MES
      </button>
    </div>
    <div
      class="btn"
      (click)="setView(CalendarView.Week)"
      [class.active]="view === CalendarView.Week"
    >
      <button
        class="mat-elevation-z2 p-0"
        mat-raised-button
        style="
          background-color: #343a40;
          color: white;
          width: 80px;
          height: 40px;
          border-radius: 10px;
        "
      >
        SEMANA
      </button>
    </div>
    <div
      class="btn"
      (click)="setView(CalendarView.Day)"
      [class.active]="view === CalendarView.Day"
    >
      <button
        class="mat-elevation-z2 p-0"
        mat-raised-button
        style="
          background-color: #343a40;
          color: white;
          width: 50px;
          height: 40px;
          border-radius: 10px;
        "
      >
        DIA
      </button>
    </div>
  </div>
</div>
<br />

<ng-template #loading>
  <div class="text-center">
    <i class="fas fa-spin fa-spinner fa-5x"></i> <br />
    Loading events...
  </div>
</ng-template>

<div>
<app-filters [headerFilters]="headerFilters" (applyFilters)="applyFilters($event)">
</app-filters>
<div [ngSwitch]="view">
  <mwl-calendar-month-view
    *ngSwitchCase="CalendarView.Month"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    [activeDayIsOpen]="activeDayIsOpen"
    (dayClicked)="dayClicked($event.day)"
    (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)"
  >
  </mwl-calendar-month-view>
  <mwl-calendar-week-view
    *ngSwitchCase="CalendarView.Week"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)"
  >
  </mwl-calendar-week-view>
  <mwl-calendar-day-view
    *ngSwitchCase="CalendarView.Day"
    [viewDate]="viewDate"
    [events]="events"
    [refresh]="refresh"
    (eventClicked)="handleEvent('Clicked', $event.event)"
    (eventTimesChanged)="eventTimesChanged($event)"
  >
  </mwl-calendar-day-view>
</div>
</div>
